export default __webpack_public_path__ + "static/media/me.47a8cf30.jpg";